export default __webpack_public_path__ + "static/media/one.deead0d8.jpeg";